import Panel from 'components/atoms/GefMui/Panel';
import PAGES from 'constants/pages';

import MainWidgets from './DashboardManager/components/MainWidgets';

export const DashboardManager = () => {
	return (
		<Panel
			className="DashboardPage"
			screenName={PAGES.dashboardManager.name}
			screenId={PAGES.dashboardManager.id}
			spacing={0}
		>
			<MainWidgets />
		</Panel>
	);
};

export default DashboardManager;
